import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { loadScriptSync } from './utils/help'

// 全局样式
import '@/styles/index.css'

// vant组件库
import '@/plugin/vant'
import 'vant/lib/index.css'

// 复制组件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 需要在pc端访问部分页面，该库会在桌面端自动将 mouse 事件转换成对应的 touch 事件
import '@vant/touch-emulator'

Vue.config.productionTip = false

// 动态加载微信js-sdk：
// jwxwork必须配合jweixin-1.2.0.js使用
// https://developer.work.weixin.qq.com/document/path/90514
// wx.miniProgram需要新版本js-sdk才能使用
let loadScriptTask = []
if (window.location.href.indexOf('/wx-sidebar') > -1) {
  loadScriptTask = [loadScriptSync('//res.wx.qq.com/open/js/jweixin-1.2.0.js'), loadScriptSync('https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js')]
} else {
  loadScriptTask = [loadScriptSync('https://res.wx.qq.com/open/js/jweixin-1.6.0.js')]
}

// vConsole插件
const isLoadVConsole = ['dev', 'test'].includes(process.env.VUE_APP_RUN_ENV) || process.env.NODE_ENV === 'development'
isLoadVConsole && loadScriptTask.push(loadScriptSync('https://cdn.bootcdn.net/ajax/libs/vConsole/3.15.1/vconsole.min.js'))

Promise.all(loadScriptTask).then(() => {
  isLoadVConsole && window.VConsole && new window.VConsole()

  new Vue({
    router,
    render: (h) => h(App)
  }).$mount('#app')
})
